import { serviceIndexQueryKey, serviceStoreMutation } from '$api-client/@tanstack/react-query.gen'
import { DogBreed } from '$api-client/types.gen'
import { CreateServiceForm, CreateServiceSchema, Input } from '$features/services/forms/create'
import { NavigableModal } from '$components'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ToastHelper } from '$components'
import { ToastType } from '$components'
import { useNavigate } from 'react-router'
import { ServiceRoutePath } from '../routes/protected'

export function CreateServiceModal() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const handleClose = () => navigate(ServiceRoutePath.Services)

  const serviceMutation = useMutation({
    ...serviceStoreMutation(),
    onSuccess: () => {
      ToastHelper.createSuccess(ToastType.Service)
      queryClient.invalidateQueries({ queryKey: serviceIndexQueryKey() })
      handleClose()
    },
    onError: () => ToastHelper.createError(ToastType.Service),
  })

  const handleSubmit = (values: CreateServiceSchema) => {
    serviceMutation.mutate({
      body: {
        name: values.name,
        description: values.description,
        colour: values.colour,
        currency: values.currency.id,
        variants: values[Input.Variants].map((variant) => ({
          is_default: variant.is_default ?? false,
          coat_type_id: variant.coat_type?.id ? Number(variant.coat_type.id) : undefined,
          size_category_id: variant.size_category?.id ? Number(variant.size_category.id) : undefined,
          breed: variant.breed?.value ? (variant.breed.value as DogBreed) : undefined,
          price_in_cents: Number(variant.price) * 100,
          duration: Number(variant.duration),
        })),
        notes: values.notes,
      },
    })
  }

  return (
    <CreateServiceForm
      isLoading={serviceMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={handleClose}
    >
      <NavigableModal onClose={handleClose}>
        <NavigableModal.Header>
          <NavigableModal.Heading>
            Create Service
          </NavigableModal.Heading>
        </NavigableModal.Header>

        <NavigableModal.Content>
          <CreateServiceForm.Content />
        </NavigableModal.Content>

        <NavigableModal.Footer>
          <CreateServiceForm.Controls />
        </NavigableModal.Footer>
      </NavigableModal>
    </CreateServiceForm>
  )
}
